// #region Imports
import axios from "axios";
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-video',
    // #endregion
    // #region Properties
    props: {
        mode: {
            type: String,
            required: false,
            default: 'player',
            validValues: ['player', 'thumbnail'],
            validator(value) {
                if (!value.length) {
                    return true;
                }
                return ['player', 'thumbnail'].includes(value);
            }
        },
        src: {
            type: String,
            required: true,
            default: ''
        },
        options: {
            type: String,
            required: false,
            default: ''
        }
    },
    data: () => ({
        _platform: '',
        _videoID: '',
        videoSource: '',
        thumbSource: ''
    }),
    // #endregion
    // #region Constructor        
    mounted() {
        this.init();
    },
    // #endregion
    // #region Watch
    watch: {
        'src': function (newValue, oldValue) {
            this.init();
        }
    },
    // #endregion
    //#region Core
    methods: {
        // #region Core
        init() {
            // #region Parse
            if (this.src) {
                if (this.src.startsWith("video://youtube/")) {
                    this._platform = 'youtube';
                    this._videoID = this.src.substring("video://youtube/".length);
                }
                else if (this.src.startsWith("video://vimeo/")) {
                    this._platform = 'vimeo';
                    this._videoID = this.src.substring("video://vimeo/".length);
                }
            }
            else {
                this._platform = '';
                this._videoID = '';
                this.videoSource = '';
                this.thumbSource = '';
            }
            // #endregion
            // #region Init
            if (this.mode === 'thumbnail') {
                this.initThumbnail();
            }
            else {
                this.initPlayer();
            }
            // #endregion
        },
        // #endregion
        // #region Thumbnail
        initThumbnail() {
            if (this._platform === 'youtube') {
                this.thumbSource = 'https://img.youtube.com/vi/' + this._videoID + '/mqdefault.jpg';
            }
            else if (this._platform === 'vimeo') {
                axios.get('https://vimeo.com/api/v2/video/' + this._videoID + '.json')
                    .then((e) => {
                    let tItems = e.data;
                    if (tItems && tItems.length > 0) {
                        this.thumbSource = tItems[0].thumbnail_medium;
                    }
                });
            }
        },
        // #endregion
        //#region Player
        initPlayer() {
            // for YouTube Videos
            if (this._platform === 'youtube') {
                this.videoSource = "https://www.youtube.com/embed/" + this._videoID;
                +(this.options ? "?" + this.options : "");
            }
            // for Vimeo Videos
            else if (this._platform === 'vimeo') {
                this.videoSource = "https://player.vimeo.com/video/" + this._videoID + (this.options ? "?" + this.options : "");
            }
        }
        // #endregion
    }
    // #endregion
});
// #endregion
